(function () {
  const SECOND = 1000;
  const MINUTE = 60 * SECOND;
  const HOUR = 60 * MINUTE;
  const DAY = 24 * HOUR;

  function parseOffsetHours(rawOffset) {
    const parsed = Number(rawOffset);
    return Number.isFinite(parsed) ? parsed : 10;
  }

  function getTimezoneDate(offsetHours) {
    const now = new Date();
    const utcMillis = now.getTime() + now.getTimezoneOffset() * MINUTE;
    return new Date(utcMillis + offsetHours * HOUR);
  }

  function parseHourMinute(value) {
    const match = String(value || "").trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!match) {
      return { hours: 0, minutes: 0 };
    }

    const hours = Math.min(23, Math.max(0, Number(match[1])));
    const minutes = Math.min(59, Math.max(0, Number(match[2])));
    return { hours, minutes };
  }

  function toTwoDigits(value) {
    return String(Math.max(0, value)).padStart(2, "0");
  }

  function getTargetTime(bar) {
    const mode = bar.dataset.timerMode || "24";
    const offsetHours = parseOffsetHours(bar.dataset.timezoneOffset);
    const nowInZone = getTimezoneDate(offsetHours);

    if (mode === "fixed") {
      const endDateRaw = bar.dataset.endDate;
      if (!endDateRaw) return null;
      const parsedDate = new Date(endDateRaw);
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate.getTime();
    }

    if (mode === "48") {
      const { hours, minutes } = parseHourMinute(bar.dataset.resetStartTime);
      const start = new Date(nowInZone);
      start.setHours(hours, minutes, 0, 0);

      const elapsed = nowInZone.getTime() - start.getTime();
      const cycle = 48 * HOUR;
      const cycleElapsed = ((elapsed % cycle) + cycle) % cycle;
      return nowInZone.getTime() + (cycle - cycleElapsed);
    }

    // Default: rolling 24h reset at local midnight in configured timezone.
    const midnight = new Date(nowInZone);
    midnight.setHours(24, 0, 0, 0);
    return midnight.getTime();
  }

  function formatParts(totalMs, showDays) {
    const safeMs = Math.max(0, totalMs);
    const days = Math.floor(safeMs / DAY);
    const remainderAfterDays = safeMs % DAY;
    const hours = Math.floor(remainderAfterDays / HOUR);
    const remainderAfterHours = remainderAfterDays % HOUR;
    const minutes = Math.floor(remainderAfterHours / MINUTE);
    const seconds = Math.floor((remainderAfterHours % MINUTE) / SECOND);

    return {
      days,
      displayDays: showDays && days > 0,
      hours: toTwoDigits(hours),
      minutes: toTwoDigits(minutes),
      seconds: toTwoDigits(seconds),
    };
  }

  function updateBar(bar) {
    const targetTime = getTargetTime(bar);
    if (targetTime == null) return;

    const now = Date.now();
    const showDays = bar.dataset.showDays === "true";
    const parts = formatParts(targetTime - now, showDays);

    const daysEl = bar.querySelector("[data-days]");
    const hoursEl = bar.querySelector("[data-hours]");
    const minutesEl = bar.querySelector("[data-minutes]");
    const secondsEl = bar.querySelector("[data-seconds]");
    const daysContainer = bar.querySelector("[data-days-container]");
    const daysSeparator = bar.querySelector("[data-days-separator]");

    if (daysEl) daysEl.textContent = String(parts.days);
    if (hoursEl) hoursEl.textContent = parts.hours;
    if (minutesEl) minutesEl.textContent = parts.minutes;
    if (secondsEl) secondsEl.textContent = parts.seconds;

    if (daysContainer) {
      daysContainer.style.display = parts.displayDays ? "" : "none";
    }
    if (daysSeparator) {
      daysSeparator.style.display = parts.displayDays ? "" : "none";
    }
  }

  function parseDurationSeconds(rawValue, fallback) {
    const parsed = Number(rawValue);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function setupRotation(bar) {
    if (bar.dataset.rotate !== "true") return;

    const primary = bar.querySelector('[data-rotate-slide="primary"]');
    const secondary = bar.querySelector('[data-rotate-slide="secondary"]');
    if (!primary || !secondary) return;

    const primaryDuration = parseDurationSeconds(bar.dataset.rotatePrimaryDuration, 3) * SECOND;
    const secondaryDuration = parseDurationSeconds(bar.dataset.rotateSecondaryDuration, 5) * SECOND;

    let showingPrimary = true;

    function showSlide(showPrimary) {
      showingPrimary = showPrimary;
      primary.hidden = !showPrimary;
      secondary.hidden = showPrimary;
      // Retrigger the fade-in animation on the visible slide.
      const visible = showPrimary ? primary : secondary;
      visible.style.animation = "none";
      void visible.offsetWidth;
      visible.style.animation = "";
    }

    function scheduleNext() {
      bar._promoRotateTimeout = setTimeout(function () {
        showSlide(!showingPrimary);
        scheduleNext();
      }, showingPrimary ? primaryDuration : secondaryDuration);
    }

    showSlide(true);
    scheduleNext();
  }

  function setupBar(bar) {
    if (!bar || bar.dataset.promoCountdownReady === "true") return;
    bar.dataset.promoCountdownReady = "true";

    updateBar(bar);
    const interval = setInterval(function () {
      updateBar(bar);
    }, SECOND);

    bar._promoCountdownInterval = interval;
    setupRotation(bar);
  }

  function initialize() {
    document.querySelectorAll("[data-promo-countdown-bar]").forEach(setupBar);
  }

  function onSectionUnload(event) {
    const section = event && event.target;
    if (!section) return;
    section.querySelectorAll("[data-promo-countdown-bar]").forEach(function (bar) {
      if (bar._promoCountdownInterval) {
        clearInterval(bar._promoCountdownInterval);
        bar._promoCountdownInterval = null;
      }
      if (bar._promoRotateTimeout) {
        clearTimeout(bar._promoRotateTimeout);
        bar._promoRotateTimeout = null;
      }
      bar.dataset.promoCountdownReady = "false";
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", initialize);
  document.addEventListener("shopify:section:unload", onSectionUnload);
})();
